import type { CompanyBranding } from "@uzverse/contracts";
import { Avatar } from "@uzverse/ui";

/** A company's square icon on its primary color, or the generic avatar when it has no branding. */
export function CompanyLogo({
  name,
  branding,
  size,
}: {
  name: string;
  branding?: CompanyBranding | undefined;
  size: number;
}) {
  if (!branding) return <Avatar name={name} size={size} />;
  return (
    <img
      className="company-logo"
      src={branding.logo.icon}
      alt=""
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size / 4),
        background: branding.colors.primary,
      }}
    />
  );
}
